module.exports = __webpack_public_path__ + "static/img/logo_4.2251eea.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/logo/logo_4.png
// module id = h2sr
// module chunks = 1